<template>
    <v-app>

      <TileSimple :values="values">

         <template v-slot:title>
            <h5>{{ $t('titles.sla_short') }} : {{ values.value }}% {{ $t('texts.sla_currentmonth') }}</h5>
         </template>

         <template v-slot:header>
            <h4>{{ values.yearly_value }}%</h4>
         </template>
<!--
         <template v-slot:dropdown>
            <b-dropdown dropdown class="float-right" variant="transparent p-0" right>
               <template slot="button-content">
                  <i class="icon-settings"></i>
               </template>
               <b-dropdown-divider></b-dropdown-divider>
               <b-dropdown-item @click="showFullGraph=true">ZOOM</b-dropdown-item>
            </b-dropdown>
         </template>
-->
         <template v-slot:message>
            <p>{{ values.message }}</p>
         </template>

         <template v-slot:graph>
            <ddoGraphBar v-if="loaded" ref="myGraphLine" :chartdata="chartdata" :options="options" :height="height"/>
         </template>

      </TileSimple>

    </v-app>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import TileSimple from '@/components/partials/TileSimple.vue';
import ddoGraphBar from '@/components/ddoGraphBar.vue';

export default {
   name: 'TileSimpleSLA',
   components: {
      TileSimple,
      ddoGraphBar,
   },

   data: function () {
      return {

         ws_code: 'service',
         ws_key: 'SLA',
         ws_stats_keyword: 'stats',
         ws_report_type: 'last12months',

         loading: false,
         loaded: false,
         chartdata: null,
         options: null,
         ZOOMoptions: null,
         height: 250,
         data_type: 'sla',
         rows: [],
         bgcolors: [],
         showFullGraph: false,

         dropdown_graph_text: i18n.t('texts.choose_dropdown_graph'),

         values : {
            value: null,
            message : null,
            labels: [],
            date: [],
            data: [],
         } 
      }
   },

   async mounted() {
      var style = getComputedStyle(document.body);
      this.bgcolors[0] = style.getPropertyValue('--success');
      this.bgcolors[1] = style.getPropertyValue('--warning');
      this.bgcolors[2] = style.getPropertyValue('--danger');

      await this.refresh_data();
   },

   methods : {

      async switch_type(report_type,data_type) {
         this.data_type = data_type;
         this.ws_report_type = report_type;
         await this.refresh_data();
      },

      async refresh_data() {
         var type = this.ws_report_type;
         var parameters = { plf_report_type: type };
         this.loaded = false;
         let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_code+'/'+this.ws_key+'/'+this.ws_stats_keyword, parameters );
         if ( api_response.error==0 ) {
            this.restructure_data(api_response.rows);
            this.loaded = true;
         }
      },

      get_max(data,_min=0) {
         var _max = _min;
         for( var i=0;i<data.length;i++ ) {
            if ( data[i]>_max ) { _max = data[i]; }
         }
         return _max;
      },

      compute_currentmonth(data) {
         if (data[0] && data[0].prl_day) {
            var _date = new Date(data[0].prl_day);
         } else {
            var _date = new Date(data[0].prl_day);
         }
         var _month = _date.getMonth();
         return _month;
      },

      build_labels(report_type,data,length) {
         var labels = [];
         var _format = 'short';
         if ( report_type=='last12months' ) {
             _format = 'monthly';
         }
         for (var i=0;i<data.length;i++) {
            labels.push( this.$api._d(data[i],_format) );
         }
         if ( labels.length<length && report_type=='month' ) {
            for (var i=labels.length;i<length;i++) {
               labels.push( '' );
            }
         }
         return labels;
      },

      build_bgcolors(values,length) {
         var bgcolors = [];
         for (var i=0;i<values.data.length;i++) {
            bgcolors.push( this.bgcolors[values.threshold[i]-1] );
         }
         if ( bgcolors.length<length ) {
            for (var i=bgcolors.length;i<length;i++) {
               bgcolors.push( '' );
            }
         }
         return bgcolors;
      },

      build_options(report_type,data) {
         var options = {
            legend: {
               display: false,
            },
            tooltips: {
               callbacks: {
                  label: function(tooltipItem, chart){
                     var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                     return datasetLabel + ' ' + parseFloat(tooltipItem.yLabel).toFixed(2)+'%';
                  }
               }
            },
            scales: {
               y: {
                  ticks: {
                     format: {
                        style: 'percent'
                     }
                  }
               },
               xAxes: [ {
                  display: false,
                  stacked: true,
               }],
               yAxes: [ {
                  display: true,
                  stacked: true,
                  ticks: {
                     min: 95,
                     stepSize: 1,
                     max: this.get_max(data),
                     callback: function (tick) {
                        return tick.toFixed(0) + '%';
                     }
                  }
               }]
            }
         };
         return options;
      },

      prepare_chart_data(values) {
         var dataset_label = '';
         switch ( this.data_type ) {
            case 'sla':
               switch( this.ws_report_type ) {
                  case 'last12months' : values.message = i18n.t('texts.sla_last12months'); break;
               }
               dataset_label = i18n.t('headers.percentages');
               break;
         }

         var _nb_of_rows = 12;
         this.chartdata = {
            labels : this.build_labels(this.ws_report_type,values.date,_nb_of_rows),
            datasets: [
               {
                  label: i18n.t('texts.level_sla'),
                  backgroundColor: this.build_bgcolors(values,_nb_of_rows),
                  data: values.data,
               },
            ]
         };
         this.options = this.build_options('month',values.data);
         this.values = values;
      },

      restructure_data(rows) {
         var values = { value: 0.00, yearly_value: 0.00, message: 'XX', labels: [], date: [], data: [], threshold: [] }
         if ( rows.length>0 ) {
            values.value = Math.round(parseFloat(rows[0].sla_rate)*100)/100;
         }
         var total = 0.00;
         for ( var i=rows.length-1; i>=0; i-- ) {
            values.date.push(rows[i].sla_full_month);
            values.data.push( parseFloat(rows[i].sla_rate) );
            values.threshold.push( rows[i].sla_threshold );
            total += parseFloat(rows[i].sla_rate);
         }
         if ( rows.length>0 ) {
            total = Math.round(total/rows.length*100)/100;
         }
         values.yearly_value = total;

         // Normalize the data :
         for ( var j=0; j<values.data.length; j++ ) {
            values.data[j] = Math.round(values.data[j]*100)/100;
         }
         this.prepare_chart_data(values);
         console.log('restructure_data, values='+JSON.stringify(values))
      },

   }

}
</script>